"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRaceParticipantById = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Returns an object representing a race participant (if they exist).
 *
 * Race is retrieved by its stringified `ObjectId`.
 * Member is retrieved by their Discord ID.
 *
 * ## Usage
 *
 * ```ts
 * const raceId: string = "89d88787e899caa8";
 * const memberId: string = "3498759483298";
 *
 * const participant: RacePlayer =
 * 	await sdk.getRaceParticipantById({ raceId, memberId });
 * ```
 *
 * @param params.raceId   - ID of the race that member participates in.
 * @param params.memberId - Discord ID of the chosen race participant.
 */
const getRaceParticipantById = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { raceId, memberId } = params;
    const url = `${BASE_URL}/races/race/${raceId}/participants/participant/${memberId}`;
    const racePlayerResponse = yield axios_1.default.get(url, { validateStatus: () => true });
    const { status, data } = racePlayerResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.getRaceParticipantById = getRaceParticipantById;
